import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/bill_send_record_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  customer_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'BillSendRecord',
  },
  customer: {
    column_type: 'belongs_to',
    column_name: 'customer',
    extra: {
      model_name: 'Customer',
      value_column: 'id',
    },
    model_name: 'BillSendRecord',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'BillSendRecord',
      options: ['pending', 'confirmed'],
    },
    model_name: 'BillSendRecord',
    column_name: 'state',
  },
  sent_at_gteq_date: {
    column_type: 'datetime',
    model_name: 'BillSendRecord',
    column_name: 'sentAt',
  },
  sent_at_lteq_date: {
    column_type: 'datetime',
    model_name: 'BillSendRecord',
    column_name: 'sentAt',
  },
}
export const formColumnsConfig = {
  'self': {
    'customer_id': { required: true, disabledUpdate: false },
    'send_method': { required: true, disabledUpdate: false },
    'sent_at': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('BillSendRecord', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('BillSendRecord', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
